import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const StatesIcon = (props) => (
  <SvgIcon viewBox="0 0 16 16" {...props}>
    <path
      d="M8.00004 1.33325C4.32404 1.33325 1.33337 4.32392 1.33337 7.99992C1.33337 11.6759 4.32404 14.6666 8.00004 14.6666C11.676 14.6666 14.6667 11.6759 14.6667 7.99992C14.6667 4.32392 11.676 1.33325 8.00004 1.33325ZM8.00004 2.66659C10.9407 2.66659 13.3334 5.05925 13.3334 7.99992C13.3334 10.9406 10.9407 13.3333 8.00004 13.3333C5.05937 13.3333 2.66671 10.9406 2.66671 7.99992C2.66671 5.05925 5.05937 2.66659 8.00004 2.66659ZM8.00004 5.99992C7.46961 5.99992 6.9609 6.21063 6.58583 6.5857C6.21075 6.96078 6.00004 7.46949 6.00004 7.99992C6.00004 8.53035 6.21075 9.03906 6.58583 9.41413C6.9609 9.7892 7.46961 9.99992 8.00004 9.99992C8.53047 9.99992 9.03918 9.7892 9.41425 9.41413C9.78933 9.03906 10 8.53035 10 7.99992C10 7.46949 9.78933 6.96078 9.41425 6.5857C9.03918 6.21063 8.53047 5.99992 8.00004 5.99992Z"
      fill={props.sx?.color || '#9C9FA5'}
    />
  </SvgIcon>
);

StatesIcon.propTypes = {
  sx: PropTypes.object,
};

export default StatesIcon;
